import React from "react";

const RelatedVtis = () => {
  return <div className="details-block">RelatedVtis</div>;
};

export default RelatedVtis;
